<script>
/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    }
  },
  methods: {
    getAccessLevelColor(item) {
      if (item === 'Administrator') return 'badge-soft-danger'
      else if (item === 'Editor') return 'badge-soft-secondary'
      else if (item === 'User') return 'badge-soft-success'
      else if (item === 'Union Administrator') return 'badge-soft-primary'
      else if (item === 'Federation Administrator') return 'badge-soft-info'
      else return 'badge-soft-dark'
    },
  },
  computed: {},
  watch: {},
  mounted() {
    //console.log('>>>>>> Image file: '+this.content.coverImage)
  },
}
</script>

<template>
  <!--div class="card custom_card">
      <div class="card-body">
        <img
          class="card-img-top img-fluid"
          src="../assets/images/small/img-1.jpg"
          alt="Card image cap"
        />
        <h6></h6>
        
        <p class="text-success text-uppercase fs-12 mb-2">Web Design</p>
        <h5><a href="#" class="text-dark">{{content.title}}</a></h5>
        <p class="text-muted mb-4" v-snip:js="1"
          >{{content.description}}</p
        >
        <div class="badge badge-soft-info custom_badge float-end">Tag 1</div>&nbsp;
        <div class="badge badge-soft-info custom_badge float-end">Tag 2</div>
        <h6></h6>
        <div>
          <a href="javascript: void(0);">
            <img
              src="../assets/images/users/avatar-3.jpg"
              alt=""
              class="avatar-sm m-1 rounded-circle"
            />
          </a>
        </div>
      </div>
      <div class="card-body border-top">
        <div class="row align-items-center">
          <div class="col-sm-auto">
            <ul class="list-inline mb-0">
              <li class="list-inline-item pe-2">
                  <i class="uil uil-calender me-1"></i> {{content.created}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div-->
  <div class="card custom_card">
    <!--img
      class="card-img-top custom_img"
      :src="content.coverImage"
      :alt="content.title"s
    /-->
    <vue-load-image>
      <img
        class="card-img-top custom_img"
        slot="image"
        :src="content.coverImage"
      />
      <img
        class="card-img-top custom_loader_img "
        slot="preloader"
        src="../assets/images/loaders/loading.gif"
      />
      <div slot="error">Unable to load image</div>
    </vue-load-image>

    <div class="card-body">
      <p class="text-success text-uppercase fs-12 mb-2" v-snip:js="1">{{
        content.topic
      }}</p>
      <h5 v-snip:js="1"
        ><a href="#" class="text-dark">{{ content.title }}</a></h5
      >
      <p class="text-muted mb-4" v-snip:js="1">{{ content.description }}</p>
      
      <span v-for="(tagInfo, index) in content.tags" :key="index">
      <span class="badge badge-soft-info custom_badge float-end text-uppercase">{{
          tagInfo
        }}</span>&nbsp;
      </span>
      <h6></h6>

      <!--div>
          <a href="javascript: void(0);">
            <img
              src="../assets/images/users/avatar-3.jpg"
              alt=""
              class="avatar-sm m-1 rounded-circle"
            />
          </a>
        </div-->
      <h6></h6>
      <div class="custom_card-body border-top">
        <p class="text-secondary text-uppercase fs-12 mb-2" v-snip:js="1"
          ><i class="uil uil-calender me-1"></i> {{ content.created }}</p
        >
      </div>
      <a
        class="btn btn-primary btn-block"
        :href="content.contentLink"
        target="blank"
        >Read More</a
      >
    </div>
  </div>
</template>

<style lang="scss">
.fs-12 {
  font-size: 10px !important;
}
.custom_badge {
  display: inline-block;
  padding: 0.25 em 0.4 em;
  font-size: 70%;
  font-weight: 500;
  line-height: 1.2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.75 rem;
}

.custom_card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1 px solid #e2e7f1;
  border-radius: 0.25 rem;
}

.custom_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: cover;
  display: block;
  width: 100%;
}

.custom_loader_img {
  border-radius: 5px 5px 0px 0px;
  height: 140px;
  object-fit: scale-down;
  display: block;
  width: 100%;
}

.custom_card-body {
  flex: 1 1 auto;
  padding: 15px 25px 5px 0px;
}

.custom_align-items-left {
  align-items: left !important;
}

.col-sm-auto {
  flex: 0 0 auto;
  width: auto;
}
</style>
